module.exports = __webpack_public_path__ + "img/90f745c.jpg";